export const rewardCardData = [
  {
    name: 'Dokyo #271',
    estimatedValue: '0,000',
    rarity: 'Common',
    image: '/assets/images/nft1.png',
  },
  {
    name: 'The Arena',
    estimatedValue: '0,000',
    rarity: 'Mythical',
    image: '/assets/images/arena-claim.png',
  },
  {
    name: 'Looty Points',
    estimatedValue: '0,000',
    rarity: 'Legendary',
    image: '/assets/images/looty-point.png',
  },
  {
    name: 'Lil Degens #957',
    estimatedValue: '0,000',
    rarity: 'Uncommon',
    image: '/assets/images/nft2.png',
  },
  {
    name: 'Dokyo #1723',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/nft3.png',
  },
  {
    name: 'Steady #003',
    estimatedValue: '0,000',
    rarity: 'Epic',
    image: '/assets/images/nft4.png',
  },
  {
    name: 'Don #554',
    estimatedValue: '0,000',
    rarity: 'Legendary',
    image: '/assets/images/nft5.png',
  },
];

export const rewardArenaCardData = [
  {
    name: '168 ARENA',
    estimatedValue: '0,000',
    rarity: 'Common',
    image: '/assets/images/reward/arena-reward-1.png',
  },
  {
    name: '336 ARENA',
    estimatedValue: '0,000',
    rarity: 'Common',
    image: '/assets/images/reward/arena-reward-2.png',
  },
  {
    name: '673 ARENA',
    estimatedValue: '0,000',
    rarity: 'Common',
    image: '/assets/images/reward/arena-reward-2.png',
  },
  {
    name: '1 039 ARENA',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/reward/arena-reward-3.png',
  },
  {
    name: '2 079 ARENA',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/reward/arena-reward-3.png',
  },

  {
    name: '3 462 ARENA',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/reward/arena-reward-5.png',
  },
  {
    name: '4 158 ARENA',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/reward/arena-reward-4.png',
  },
  {
    name: '6 925 ARENA',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/reward/arena-reward-5.png',
  },
  {
    name: '13 850 ARENA',
    estimatedValue: '0,000',
    rarity: 'Legendary',
    image: '/assets/images/reward/arena-reward-6.png',
  }
];

export const rewardCardQiibeeData = [
  {
    name: 'Dokyo #271',
    estimatedValue: '0,000',
    rarity: 'Common',
    image: '/assets/images/credit.png',
  },
  {
    name: 'Lil Degens #957',
    estimatedValue: '0,000',
    rarity: 'Uncommon',
    image: '/assets/images/credit.png',
  },
  {
    name: 'Dokyo #1723',
    estimatedValue: '0,000',
    rarity: 'Rare',
    image: '/assets/images/credit.png',
  },
  {
    name: 'Steady #003',
    estimatedValue: '0,000',
    rarity: 'Epic',
    image: '/assets/images/credit.png',
  },
  {
    name: 'Don #554',
    estimatedValue: '0,000',
    rarity: 'Legendary',
    image: '/assets/images/credit.png',
  },
];

export const recentActivityData = [
  {
    projectName: 'Gommies #564',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/nft6.png', // Replace with actual image paths
  },
  {
    projectName: 'Silver Key',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/nft7.png',
  },
  {
    projectName: 'Bronze Key',
    estimatedValue: '8,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/nft8.png',
  },
  {
    projectName: 'Enforcer Mac',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/nft9.png',
  },
  {
    projectName: 'Gold Key',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/nft10.png',
  },
  {
    projectName: '5 tickets',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/raffle-banner.png',
  },
  {
    projectName: '400 Looty points',
    estimatedValue: '0,000',
    rewardOpened: '00h 00m ago',
    image: '/assets/images/looty-epic.png',
  },
];

export const openBoxCardsData = [
  {
    claimStatus: 'Claiming soon',
    claimTime: '00d 00h 00m 00s',
    rewardValue: '$2,118',
    buttonText: 'Mint',
    projectName: 'Phaver',
    token: 'ETH',
    progress: 10,
    totalProgress: 1000,
    image: '/assets/images/phaver.jpg',
    imageLogo: '/assets/images/project1_logo.png',
  },
  {
    claimStatus: 'Claiming live',
    claimTime: '00h 00m 00s',
    rewardValue: '$2,119',
    buttonText: 'Open box',
    projectName: 'AscendEX',
    token: 'AMX',
    progress: 20,
    totalProgress: 1000,
    image: '/assets/images/qbx-socials-cover-d.jpg',
    imageLogo: '/assets/images/project2_logo.png',
  },
];

export interface HomeBannerData {
  collectionImage: string;
  id: string;
  title: string;
  btnText: string;
  image: string;
  status: string;
  slug: string;
  website: string;
  twitter: string;
  projectType: string;
  stageId: string;
  showButtons?: boolean;
}

export const homeBannerData: HomeBannerData[] = [
  {
    id: '',
    stageId: '',
    title: 'avax x inspect',
    slug: 'avax',
    btnText: 'Claim',
    image: '/assets/images/avax-banner.png',
    status: 'Coming soon',
    collectionImage: '/assets/images/avax_logo.png',
    website: 'https://www.avax.network/',
    twitter: 'https://x.com/avax',
    projectType: 'avax',
    showButtons: false,
  },
  {
    id: '',
    stageId: '',
    title: 'The Arena',
    slug: 'arena',
    btnText: 'Claim',
    image: '/assets/images/arena-banner.png',
    status: 'Live',
    collectionImage: '/assets/images/arena-logo.png',
    website: 'https://arena.social/',
    twitter: 'https://x.com/TheArenaApp',
    projectType: 'avax',
    showButtons: false,
  },
  {
    id: '',
    stageId: '',
    title: 'MultiversX',
    slug: 'multiversx',
    btnText: 'Earn',
    image: '/assets/images/multiversx-banner.png',
    status: 'Live',
    collectionImage: '/assets/images/multiversx-logo.png',
    website: 'https://www.multiversx.com',
    twitter: 'https://x.com/MultiversX',
    projectType: 'EGLD',
    showButtons: true,
  },
];

export interface MultiversPointsCardData {
  phase: string;
  title: string;
  description: string;
  status: string;
  slug: string;
  bgImage: string;
  pointsToEarn: string;
  isClaimed?: boolean;
}

export const multiversPointsCardData: MultiversPointsCardData[] = [
  {
    phase: 'PHASE 1',
    title: 'xPortal Wallet Creation',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'xportal-wallet-creation',
    bgImage: '/assets/images/tasks/task-1.png',
    pointsToEarn: '120,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Active Wallet',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'active-wallet',
    bgImage: '/assets/images/tasks/task-2.png',
    pointsToEarn: '370,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Follow @MultiversX on X',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'follow-multiversx-on-x',
    bgImage: '/assets/images/tasks/task-3.png',
    pointsToEarn: '120,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Follow @Looty_fi on X',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'follow-looty-fi-on-x',
    bgImage: '/assets/images/tasks/task-4.png',
    pointsToEarn: '430,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Follow @xPortalApp on X',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'follow-xportalapp-on-x',
    bgImage: '',
    pointsToEarn: '0',
  },
  {
    phase: 'PHASE 1',
    title: "Join MultiversX's Telegram",
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'join-multiversxs-telegram',
    bgImage: '/assets/images/tasks/task-5.png',
    pointsToEarn: '120,000',
  },

  {
    phase: 'PHASE 1',
    title: 'Like & RT Twitter Posts',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'like-and-rt-twitter-posts',
    bgImage: '/assets/images/tasks/task-6.png',
    pointsToEarn: '240,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Buy $EGLD',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'buy-egld',
    bgImage: '/assets/images/tasks/task-7.png',
    pointsToEarn: '240,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Subscribe Full Shard Podcast',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'subscribe-full-shard-podcast',
    bgImage: '/assets/images/tasks/task-8.png',
    pointsToEarn: '120,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Stake $EGLD',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'stake-egld',
    bgImage: '/assets/images/tasks/task-9.png',
    pointsToEarn: '120,000',
  },
  {
    phase: 'PHASE 1',
    title: 'Watch Content Video',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    status: 'To Do',
    slug: 'watch-content-video',
    bgImage: '/assets/images/tasks/task-10.png',
    pointsToEarn: '120,000',
  },
];

export const multiversMainPrizesData = [
  {
    name: '60 $EGLD',
    estimatedValue: '0,000',
    image: '/assets/images/reward-image-5.png',
    rarity: 'Rare',
  },
  {
    name: '100 $EGLD80',
    estimatedValue: '0,000',
    image: '/assets/images/reward-image-5.png',
    rarity: 'Epic',
  },
  {
    name: '170 $EGLD',
    estimatedValue: '0,000',
    image: '/assets/images/reward-image-5.png',
    rarity: 'Legendary',
  },
  {
    name: '150 $EGLD',
    estimatedValue: '0,000',
    image: '/assets/images/reward-image-5.png',
    rarity: 'Legendary',
  },
  {
    name: '200 $EGLD',
    estimatedValue: '0,000',
    image: '/assets/images/reward-image-5.png',
    rarity: 'Mythical',
  },
];
